import { IntegrationEditFormDataViewFragment } from 'generated/graphql';
import { mapEdgeDataToChannelsInGuild } from 'v2/core/repository/edge-server/integrations/editIntegrations/utils/mapEdgeDataToChannelsInGuild';
import { mapEdgeDataToChannelsInWorkspace } from 'v2/core/repository/edge-server/integrations/editIntegrations/utils/mapEdgeDataToChannelsInWorkspace';
import { mapEdgeDataToForms } from 'v2/core/repository/edge-server/integrations/editIntegrations/utils/mapEdgeDataToForms';
import { mapEdgeDataToSurveys } from 'v2/core/repository/edge-server/integrations/editIntegrations/utils/mapEdgeDataToSurveys';

export const mapEditIntegrationFormData = (
  edgeFormData: IntegrationEditFormDataViewFragment,
): IntegrationEditFormDataViewFragment => {
  return {
    surveyMonkey: {
      surveys: mapEdgeDataToSurveys(edgeFormData?.surveyMonkey?.surveys ?? []),
    },
    typeform: {
      forms: mapEdgeDataToForms(edgeFormData?.typeform?.forms ?? []),
    },
    salesforce: edgeFormData?.salesforce,
    discord: {
      channelsInGuild: mapEdgeDataToChannelsInGuild(
        edgeFormData?.discord?.channelsInGuild ?? [],
      ),
    },
    slack: {
      channelsInWorkspace: mapEdgeDataToChannelsInWorkspace(
        edgeFormData?.slack?.channelsInWorkspace ?? [],
      ),
      refreshID: edgeFormData?.slack?.refreshID,
    },
    qualtrics: {
      surveys: edgeFormData.qualtrics?.surveys ?? [],
    },
  };
};
